function init(config) {
	'use strict';

	var selector = (config && config.selector) || '.header';
	var scrolledClass = (config && config.scrolledClass) || '--scrolled';
	var threshold = (config && typeof config.threshold === 'number') ? config.threshold : 10;
	var header = document.querySelector(selector);

	if (!header) {
		return;
	}

	var ticking = false;

	function update() {
		if (window.pageYOffset > threshold) {
			header.classList.add(scrolledClass);
		} else {
			header.classList.remove(scrolledClass);
		}
		ticking = false;
	}

	function onScroll() {
		if (!ticking) {
			window.requestAnimationFrame(update);
			ticking = true;
		}
	}

	window.addEventListener('scroll', onScroll, { passive: true });
	update();
}

export default {
	init,
};
